<template>
  <div class="" v-loading="loading">
    <back />

    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm" :disabled="type == 1 ? true : false">
      <el-row type="flex" justify="">
        <el-col :span="10">
          <el-form-item label="协议名称" prop="protocolName" disabled>
            <el-input v-model="ruleForm.protocolName" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="类型" prop="protocolType">
            <el-select v-model="ruleForm.protocolType" placeholder="请选择" disabled>
              <el-option label="游学" :value="1"></el-option>
              <el-option label="问卷" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="">
        <el-col :span="23">
          <el-form-item label="正文" prop="protocolContent">
            <editor :htmls="ruleForm.protocolContent" :disabled="type == 1 ? true : false" @change="onChange" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="btn" v-if="type == 2">
      <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
    </div>
  </div>
</template>

<script>
import editor from "@/components/editor.vue"
function createForm() {
  return {
    protocolName: "",
    protocolType: "",
    protocolContent: "",
  }
}
export default {
  components: { editor },
  data() {
    return {
      id: this.$route.query.id,
      type: this.$route.query.type,
      loading: false,
      ruleForm: createForm(),
      rules: {
        protocolName: [{ required: true, message: "请输入内容", trigger: "blur" }],
        // protocolType: [{ required: true, message: "请输入内容", trigger: "blur" }],
        protocolContent: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
      action: this.$axios.defaults.baseURL + this.$api.uploadFile,
    }
  },
  created() {
    switch (this.type) {
      case 1:
        document.title = "查看"
        break
      case 2:
        document.title = "修改"
        break
    }
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$axios
        .get(`${this.$api.protocolInfoselectProtocolInfoDetail}`, {
          params: {
            id: this.id,
          },
        })
        .then(res => {
          this.ruleForm = res.result
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 文件上传前
    beforeUploads(file) {
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png"
      // const isLt5M = file.size / this.$$upsize
      if (!isJPG) {
        this.$message.error("图文只支持jpg、png、jpeg，请调整格式再上传!")
      }
      // if (!isLt5M) {
      //   this.$message.error("上传图片大小不能超过 1MB!")
      // }
      // return isJPG && isLt5M
      return isJPG
    },
    // 删除图片
    onRemove(form, str) {
      this.$set(this[form], str, "")
    },
    // 上传成功
    uploadSuccess(form, str) {
      return (response, file, fileList) => {
        if (response.code == 100) {
          this.$set(this[form], str, response.result.fileUrl)
        } else {
          this.$message.error(response.desc)
        }
      }
    },
    onChange(value) {
      this.ruleForm.protocolContent = value
    },
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.loading = true
          let params = {
            protocolName: this.ruleForm.protocolName,
            protocolType: this.ruleForm.protocolType,
            protocolContent: this.ruleForm.protocolContent,
            id: this.id,
          }
          this.$axios
            .post(this.$api.protocolInfoupdateProtocolInfo, params)
            .then(res => {
              this.loading = false
              this.$message.success(`修改成功`)
              setTimeout(() => {
                this.$router.go(-1)
              }, 1000)
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.desc)
            })
        } else {
          this.$message.error("提交失败")
          return false
        }
      })
    },
  },
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped lang="scss">
.ruleForm {
  margin-top: 30px;
  .pic_uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    ::v-deep .el-upload:hover {
      border-color: var(--themeColor);
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: var(--themeColor);
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }

    ::v-deep .el-upload--picture-card {
      background-color: #fff;
    }

    ::v-deep .el-upload-list__item-thumbnail {
      object-fit: cover;
    }

    .picurl {
      width: 100px;
      height: 100px;
      display: block;
      object-fit: cover;
    }
  }

  .delpic_uploader {
    position: absolute;
    top: -10px;
    left: 95px;
    color: red;
    font-size: 20px;
    cursor: pointer;
  }
}
.btn {
  text-align: center;
  margin: 20px 0;
  .el-button {
    width: 120px;
  }
}
</style>
